import { render } from "./importAssessmentSuccessful.vue?vue&type=template&id=5e4835fe&scoped=true"
import script from "./importAssessmentSuccessful.vue?vue&type=script&lang=js"
export * from "./importAssessmentSuccessful.vue?vue&type=script&lang=js"

import "./importAssessmentSuccessful.vue?vue&type=style&index=0&id=5e4835fe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4835fe"]])

export default __exports__